import React, { useEffect, useState } from "react";
import useTable from "../../../../../components/useTable";
import axios from 'axios';

//UI
import { Input } from "../../../../../ui/inputs/Input";
import { InfoButton, WarningButton } from "../../../../../ui/buttons/Button";
const headCells = [
  {
    id: "codConcepto",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cod. Concepto",
    textAlign: "center",
  },
  {
    id: "nombre",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nombre",
    textAlign: "center",
  },
  {
    id: "asignaciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Valor",
    textAlign: "center",
  },
  {
    id: "deducciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Deducciones",
    textAlign: "center",
  },
];
export default function TablaVisualizarNomina(props) {
  var op = require('../../../../../../src/modulos/datos');

  let token = localStorage.getItem('jwtToken');
  const [activate, setActivate] = useState(false);

  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [values, setValues] = useState({
    cedfam: ''
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    records,
    headCells,
    filterFn
  );


  const seleccionarNomina = (codIntegrante) => {
    console.log('seleccionar nomina con codIntegrante: ' + codIntegrante);
    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;

    let id = codIntegrante;
    let nomtab = 'temphistnom';
    let nomid = 'codint';
    let bloquear = true;
    let orden = ' tipcon,codconcep ';
    let endpoint = `${op.conexion}/api/nomina/seleccionaridstringesquema?id=${id}&nomtab=${nomtab}&nomid=${nomid}&bloquear=${bloquear}&esquema=${esquema}&orden=${orden}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          console.log(response.data);

          //          setRecords(response.data);


        }
      })
      .catch(error => {
        setMensaje({
          mostrar: true,
          titulo: 'Error',
          texto: error.response?.data?.message || 'Error al cargar el registro',
          icono: 'error'
        });
      })
      .finally(() => setActivate(false));
  };

  useEffect(() => {
    console.log('hola desde visualizar nomina');
    seleccionarNomina(props.codIntegrante);

  }, [props.codIntegrante]);

  return (
    <div className="col-12 m-0 p-0 d-flex flex-wrap">
      <div className="col-6 m-0 mb-2 p-0">
        <Input label="Período:" />
      </div>
      <div className="col-6 m-0 mb-2 p-0 pl-2">
        <Input label="Integrante:" />
      </div>
      <div className="col-11 m-0 p-0">
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0", cursor: 'pointer', background: values.cedfam === item.cedfam ? "lightskyblue" : "white" }} onClick={seleccionarFila(item)}>
                  <td className="text-center">{item.cedfam}</td>
                  <td className="text-center">{item.nomfam}</td>
                  <td className="text-center">{item.sexfam === 1 ? 'FEMENINO' : 'MASCULINO'}</td>
                  <td className="text-center">{item.nacfam}</td>
                  <td className="text-center">{moment.utc(item.fecnac).format('DD-MM-YYYY')}</td>
                  <td className="text-center">{item.parent}</td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
      </div>
      <div className="col-1 m-0 p-0 d-flex flex-column gap-2 align-items-center justify-content-center">
        <div className="col-auto m-0 p-0">
          <InfoButton icon="fa-eye m-0" />
        </div>
        <div className="col-auto m-0 p-0">
          <WarningButton icon="fa-edit m-0" />
        </div>
      </div>
    </div>
  );
}
